import { from, Observable, range, throwError, timer } from 'rxjs';
import { catchError, flatMap, retryWhen, share, switchMap, take, tap, zip } from 'rxjs/operators';
export function createShareRefreshing() {
    var resource = null;
    return function (fn) {
        if (resource) {
            return resource;
        }
        resource = fn().pipe(tap(function () {
            resource = null;
        }), catchError(function (err) {
            resource = null;
            throw err;
        }), share());
        return resource;
    };
}
function isNeedRetryDefault(err) {
    return err.status === 503;
}
function getDefault(option, defaultValue) {
    return option === 0 ? 0 : option || defaultValue;
}
function getDefaultFn(option, defaultValue) {
    return typeof option === 'function' ? option : defaultValue;
}
var RequestManager = /** @class */ (function () {
    function RequestManager(token, shareRefreshing, retryOptions) {
        if (retryOptions === void 0) { retryOptions = {}; }
        this.token = token;
        this.shareRefreshing = shareRefreshing || createShareRefreshing();
        this.retryOptions = {
            isNeedRetry: getDefaultFn(retryOptions.isNeedRetry, isNeedRetryDefault),
            retryCount: getDefault(retryOptions.retryCount, 3),
            timeout: getDefault(retryOptions.timeout, 1000)
        };
    }
    RequestManager.prototype.run = function (task) {
        var _this = this;
        if (typeof task !== 'function') {
            throw new Error('RequestManager error: bad arguments');
        }
        var runTask = function () {
            try {
                var stream = task();
                if (!stream && stream !== 0) {
                    return throwError(new Error('RequestManager error: bad return value from task'));
                }
                return from(stream);
            }
            catch (err) {
                return throwError(err);
            }
        };
        return Observable.create(function (observer) {
            return observer.next(runTask());
        }).pipe(switchMap(function (v) { return v; }), retryWhen(function (attempts) {
            return attempts.pipe(zip(range(1, 2)), flatMap(function (_a) {
                var error = _a[0], count = _a[1];
                if (count > 1) {
                    return throwError(error);
                }
                if (error.status === 401) {
                    return from(_this.token.hasToken()).pipe(switchMap(function (hasToken) {
                        if (hasToken) {
                            return _this.shareRefreshing(function () {
                                return from(_this.token.refresh()).pipe(catchError(function (err) {
                                    _this.token.clear();
                                    return throwError(err);
                                }));
                            }).pipe(take(1));
                        }
                        return throwError(error);
                    }));
                }
                return throwError(error);
            }));
        }), retryWhen(function (attempts) {
            return attempts.pipe(zip(range(1, _this.retryOptions.retryCount)), flatMap(function (_a) {
                var error = _a[0], count = _a[1];
                if (count > 3) {
                    return throwError(error);
                }
                if (_this.retryOptions.isNeedRetry(error)) {
                    return timer(count * _this.retryOptions.timeout);
                }
                return throwError(error);
            }));
        }));
    };
    return RequestManager;
}());
export { RequestManager };
//# sourceMappingURL=RequestManager.js.map